module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/@oppein-lib/op-upload/~/axios/lib/env/data.js
// module id = 816
// module chunks = 41